var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useContext, useEffect, useState } from 'react';
import { MarketSection, MyAssetsTab } from '../../app/router/config';
import { CurrencyContext } from '../../context/currency';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { TokenType } from '../../types/common';
import { MAX_POWER_VALUE, MIN_POWER_VALUE, getPowersToFilter } from '../../utils/card-powers';
import { getMintPassNameFromKey } from '../../utils/filters';
import { getImxAssets } from '../../utils/imx-assets';
import { metadataFactions, metadataSeasons } from '../../utils/products';
export var AssetsOrderBy;
(function (AssetsOrderBy) {
    AssetsOrderBy["NAME"] = "name";
    AssetsOrderBy["DATE"] = "updated_at";
})(AssetsOrderBy || (AssetsOrderBy = {}));
export function useMyAssets(filters, section) {
    var _a = useContext(LoadingContext), imxLoading = _a.imxLoading, setImxLoading = _a.setImxLoading;
    var _b = useContext(UserContext), selectedWallet = _b.selectedWallet, fees = _b.fees;
    var _c = useContext(CurrencyContext), imxClient = _c.imxClient, queue = _c.queue, parseCurrencyQuantity = _c.parseCurrencyQuantity;
    var _d = useState(null), assets = _d[0], setAssets = _d[1];
    var _e = useState(undefined), cursor = _e[0], setCursor = _e[1];
    var _f = useState(-1), remaining = _f[0], setRemaining = _f[1];
    var _g = useState(false), initialized = _g[0], setInitialized = _g[1];
    useEffect(function () {
        setAssets(null);
    }, [section]);
    useEffect(function () {
        if (section === MarketSection.MINT_PASSES) {
            filters.actions.setTokenTypes([TokenType.MINT_PASS]);
        }
        else if (section === MarketSection.ARISE) {
            filters.actions.setTokenTypes([TokenType.ARISE_COIN]);
        }
    }, [section]);
    useEffect(function () {
        setAssets(null);
        getAssets({ refresh: true });
    }, [
        imxClient,
        fees,
        filters.state.tokenTypes,
        filters.state.advancements,
        filters.state.collections,
        filters.state.sets,
        filters.state.factions,
        filters.state.elements,
        filters.state.rarities,
        filters.state.minPower,
        filters.state.maxPower,
        filters.state.grades,
        filters.state.foils,
        filters.state.ranks,
        filters.state.animationLevels,
        filters.state.cardTypes,
        filters.state.mintPassTypes,
        filters.state.numberings,
        filters.state.searchQuery.value,
        filters.state.orderBy,
        filters.state.direction,
        selectedWallet,
    ]);
    function getAssets(options) {
        return __awaiter(this, void 0, void 0, function () {
            var parsedFilters, result, container;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!imxClient ||
                            (remaining === 0 && !(options === null || options === void 0 ? void 0 : options.refresh)) ||
                            imxLoading ||
                            !fees ||
                            !selectedWallet ||
                            filters.state.tab !== MyAssetsTab.ALL)
                            return [2 /*return*/];
                        setImxLoading(true);
                        setInitialized(true);
                        setCursor((options === null || options === void 0 ? void 0 : options.refresh) ? undefined : cursor);
                        parsedFilters = {
                            tokenType: filters.state.tokenTypes.length > 0 ? filters.state.tokenTypes : undefined,
                            season: filters.state.collections.length > 0
                                ? filters.state.collections.map(function (collection) { return metadataSeasons[collection - 1]; })
                                : undefined,
                            set: filters.state.sets.length > 0 ? filters.state.sets.map(function (set) { return set.toString(); }) : undefined,
                            faction: filters.state.factions.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.factions.map(function (faction) { return metadataFactions[faction]; })
                                : undefined,
                            advancement: filters.state.advancements.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.advancements
                                : undefined,
                            element: filters.state.elements.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.elements
                                : undefined,
                            grade: filters.state.grades.length > 0 &&
                                (filters.state.tokenTypes[0] === TokenType.CARD || filters.state.tokenTypes[0] === TokenType.SOUVENIR_CARD)
                                ? filters.state.grades
                                : undefined,
                            rarity: filters.state.rarities.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.rarities
                                : undefined,
                            power: filters.state.tokenTypes[0] === TokenType.CARD &&
                                (filters.state.minPower !== MIN_POWER_VALUE || filters.state.maxPower !== MAX_POWER_VALUE)
                                ? getPowersToFilter(filters.state.minPower, filters.state.maxPower)
                                : undefined,
                            rank: filters.state.ranks.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.ranks.map(function (rank) { return rank.toString(); })
                                : undefined,
                            foil: filters.state.foils.length === 1 &&
                                (filters.state.tokenTypes[0] === TokenType.CARD || filters.state.tokenTypes[0] === TokenType.SOUVENIR_CARD)
                                ? filters.state.foils.map(function (value) { return value === true; })
                                : undefined,
                            animationLevel: filters.state.animationLevels.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.animationLevels
                                : undefined,
                            cardType: filters.state.cardTypes.length > 0 && filters.state.tokenTypes[0] === TokenType.CARD
                                ? filters.state.cardTypes
                                : undefined,
                            name: filters.state.mintPassTypes.length > 0 && filters.state.tokenTypes[0] === TokenType.MINT_PASS
                                ? getMintPassNameFromKey(filters.state.mintPassTypes)
                                : undefined,
                            numbering: filters.state.numberings.length > 0 ? filters.state.numberings.map(function (value) { return value.toString(); }) : undefined,
                        };
                        return [4 /*yield*/, getImxAssets(imxClient, filters.state.tokenTypes[0], selectedWallet.address, queue, assets, parsedFilters, filters.state.orderBy, filters.state.direction, cursor, remaining, parseCurrencyQuantity, __assign(__assign({}, options), { assetName: filters.state.searchQuery.value, withOrders: true }))];
                    case 1:
                        result = _a.sent();
                        setInitialized(true);
                        setAssets(result.assets);
                        setCursor(result.cursor);
                        setRemaining(result.remaining);
                        if (options === null || options === void 0 ? void 0 : options.refresh) {
                            container = window.document.getElementById('my-assets-all-grid');
                            container === null || container === void 0 ? void 0 : container.scrollTo({ top: 0 });
                        }
                        setImxLoading(false);
                        return [2 /*return*/];
                }
            });
        });
    }
    function loadMoreAssets() {
        getAssets({ refresh: false });
    }
    return {
        assets: assets,
        initialized: initialized,
        getAssets: getAssets,
        loadMoreAssets: loadMoreAssets,
    };
}
